import { trpc } from './trpc';
import type {
  ReportCatalogItem,
  ReportExecutionResult,
  ReportFilters,
} from './reports.types';

export type { ReportCatalogItem, ReportExecutionResult, ReportFilters, ReportGranularity } from './reports.types';

type ReportsTrpcSlice = {
  reports: {
    catalog: {
      useQuery: (
        input?: void,
        opts?: Parameters<typeof trpc.orders.list.useQuery>[1],
      ) => Omit<ReturnType<typeof trpc.orders.list.useQuery>, 'data'> & {
        data: ReportCatalogItem[] | undefined;
      };
    };
    execute: {
      useQuery: (
        input: { reportId: string; filters: ReportFilters },
        opts?: Parameters<typeof trpc.orders.list.useQuery>[1],
      ) => Omit<ReturnType<typeof trpc.orders.list.useQuery>, 'data'> & {
        data: ReportExecutionResult | undefined;
      };
    };
  };
};

/** Explicit slice — nested `reports` router is missing from bundled AppRouter in vite-plugin-checker. */
const reportsTrpc = trpc as typeof trpc & ReportsTrpcSlice;

export const useReportsCatalog = () => reportsTrpc.reports.catalog.useQuery();

export const useReportData = (
  reportId: string,
  filters: ReportFilters,
  options?: { enabled?: boolean },
) =>
  reportsTrpc.reports.execute.useQuery(
    { reportId, filters },
    { enabled: options?.enabled !== false && Boolean(reportId) },
  );
